import { createContext, type ReactNode, use } from 'react';

export type TFunction = (key: string, vars?: Record<string, string | number>) => string;

const I18nContext = createContext<TFunction>((key) => key);

interface I18nProviderProps {
  t: TFunction;
  children: ReactNode;
}

export const I18nProvider = ({ t, children }: I18nProviderProps) => <I18nContext value={t}>{children}</I18nContext>;

export const useTranslation = (): TFunction => use(I18nContext);
